import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "subscription-column-totals" }
const _hoisted_2 = { class: "total-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("sup", { class: "total-note-marker" }, "*", -1 /* HOISTED */)
const _hoisted_4 = { class: "total-row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("sup", { class: "total-note-marker" }, "*", -1 /* HOISTED */)
const _hoisted_6 = { class: "total-row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("sup", { class: "total-note-marker" }, "**", -1 /* HOISTED */)
const _hoisted_8 = { class: "subscription-column-vat-note" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("sup", { class: "total-note-marker" }, "*", -1 /* HOISTED */)
const _hoisted_10 = {
  key: 0,
  class: "subscription-column-vat-note"
}
const _hoisted_11 = {
  key: 1,
  class: "cart-total-reseller"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.carttype == 'shopping-cart')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h6", null, [
              _createTextVNode(_toDisplayString(_ctx.__("Total Setup and Purchase")), 1 /* TEXT */),
              _hoisted_3
            ]),
            _createElementVNode("h6", null, _toDisplayString($setup.ioi_format_currency($props.subscription_object.setup_total_in_basket || 0.0, $props.subscription_object.currency)), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h6", null, [
              _createTextVNode(_toDisplayString(_ctx.__("Total Subscription")), 1 /* TEXT */),
              _hoisted_5
            ]),
            _createElementVNode("h6", null, _toDisplayString($setup.ioi_format_currency($props.subscription_object.subscription_total_in_basket || 0.0, $props.subscription_object.currency)), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h6", null, [
              _createTextVNode(_toDisplayString(_ctx.__("Setup time")), 1 /* TEXT */),
              _hoisted_7
            ]),
            _createElementVNode("h6", null, _toDisplayString($props.subscription_object.setup_time_in_basket) + " " + _toDisplayString(_ctx.__("Hours")), 1 /* TEXT */)
          ]),
          _createElementVNode("p", _hoisted_8, [
            _createTextVNode(_toDisplayString(_ctx.__("Prices exclude VAT")), 1 /* TEXT */),
            _hoisted_9
          ]),
          _createCommentVNode(" The basket's sum says it holds a variable price, as the floating cart does\n\t\t\t     (FloatingCart.vue): the note opens the rules of those of its products that\n\t\t\t     have one (PriceRuleTrigger.vue), and is plain text when none has. "),
          ($setup.variable_basket_lines.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                _createVNode($setup["PriceRuleTrigger"], {
                  rules: $setup.variable_basket_rules,
                  text: _ctx.__('contains variable price, see rules')
                }, null, 8 /* PROPS */, ["rules", "text"])
              ]))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["SetupTimeFootnote"], {
      subscription_items: $props.subscription_object.subscription_items
    }, null, 8 /* PROPS */, ["subscription_items"]),
    _createCommentVNode(" Read-only, and part of the summary rather than of the consent form below:\n\t\t     it sits under the setup-time footnote, above the separator that opens\n\t\t     CartValidation. The navbar badge is where the reseller gets changed (later:\n\t\t     its own page), so there is no control of any kind here.\n\t\t     reseller_display_name is resolved server-side through that badge's own\n\t\t     resolver (www/subscription.py), placeholder included. It is absent from a\n\t\t     guest's locally built cart, and empty only when the placeholder record itself\n\t\t     is missing; either way the label would stand alone, so the line goes instead. "),
    ($props.carttype == 'shopping-cart' && $props.subscription_object.reseller_display_name)
      ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.__("My selected reseller")) + ": " + _toDisplayString($props.subscription_object.reseller_display_name), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ]))
}